import React, { useContext, useEffect, useState } from "react";
import {Card, CardContent, Stack, Typography, Box, LinearProgress} from "@mui/material";
import moment from "moment";
import 'moment/locale/fr'; // Import French locale for moment.js
import SellPercent from "./SellPercent";
import { Context } from "../../App";

export default function EventInfoCard({ event }) {
    const { setIsConnected } = useContext(Context);
    const [loading, setLoading] = useState(true);
    const [sellInfo, setSellInfo] = useState(null);
    const [percent, setPercent] = useState(0);
    const [label, setLabel] = useState('');
    const [info, setInfo] = useState('');
    const [boldInfo, setBoldInfo] = useState(0);

    useEffect(()=> {
        if (!event) return;
        setLoading(true);

        fetch(`${process.env.REACT_APP_API_URL}/adm/events/${event._id}/sell`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`
            }
        }).then(async response => {
            const token = response.headers.get('x-auth-token');
            if (response.status === 401) {
                sessionStorage.clear();
                setIsConnected(false);
            } else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'));
                }
                if (response.status === 200) {
                    const json = await response.json();
                    if (json && json._id) delete json._id; // Remove _id if not needed

                    setSellInfo(json || { count: 0, recette: 0 });
                    if (json && json.count > 0) {

                        if(event.places > 0) {
                            setPercent(Math.round((json.count / event.places) * 10000)/100);
                            setBoldInfo(json.count);
                            setLabel('Places vendus');
                            setInfo(event.places-json.count + ' places restantes');
                        
                        }else if (event.objectifBillets > 0) {
                            setPercent(Math.round((json.count / event.objectifBillets) * 10000)/100);
                            setBoldInfo(json.count);
                            setLabel('Billets vendus (recette : ' + json.recette.toFixed(2)+ ' €)');
                            setInfo('Objectif : ' + event.objectifBillets + ' billets');
                        
                        } else if (event.objectifRecette > 0) {
                            setPercent(Math.round((json.recette / event.objectifRecette) * 10000)/100);
                            setBoldInfo(json.recette.toFixed(2)+ ' €');
                            setLabel('Recette générée');
                            setInfo('Objectif : ' + event.objectifRecette + ' €');
                        
                        } else {
                            setPercent(null);
                            setLabel('Recette générée');
                            setInfo(json.count + ' billets vendus');
                        }
                    } else {
                        setPercent(null);
                        setLabel('Aucun billet vendu');
                    }
                }
            }
        }).catch(error => {
            console.error("Error fetching event details:", error);
        }).finally(() => {
            setLoading(false);
        });
    }, [event])

    return (
        <Card sx={{transition: 'all 0.3s ease', height: '100%', '&:hover': {boxShadow: 3, transform: 'translateY(-2px)'}}}>
            <img src={process.env.REACT_APP_API_URL.concat(event.image)} alt="Affiche évènement" height={150} width={'100%'} style={{objectFit:'cover'}} />
            {loading && <LinearProgress />}
            <CardContent>
                <Typography variant="h6" component="h3" gutterBottom>
                    {event.titre}
                </Typography>
                <Typography variant="body2" color="textSecondary" gutterBottom>{moment.utc(event.date).format('LL')}</Typography>
                <Typography variant="body2" color="textSecondary" gutterBottom>{event.lieu}</Typography>

                {!!sellInfo && <SellPercent {...{...sellInfo, boldInfo, percent, label, info}} />}
            </CardContent>
        </Card>
    )
}